import React from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';
import FilterItem from 'components/FilterItem';

import { ReactComponent as Chevron } from 'icons/Chevron.svg';

import DropdownList from 'styled/DropdownList';
import FilterWrapper from './FilterWrapper';
import ActiveFilter from './ActiveFilter';
import PopupContainer from './PopupContainer';
import RotatedChevron from './RotatedChevron';

class FiltersDropdown extends React.PureComponent {
  state = {
    isOpen: false,
  };

  handleFilterChange = (item) => {
    this.props.onFilterChange(item);

    this.setState({
      isOpen: false,
    });
  }

  handlePopupOpen = () => {
    this.setState({ isOpen: true });
  }

  handleClickOnBackdrop = () => {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <FilterWrapper style={this.props.style}>
        <ActiveFilter onClick={this.handlePopupOpen}>
          <span>{this.props.activeFilter.label}</span>

          <RotatedChevron style={{ transform: this.state.isOpen ? 'rotate(180deg)' : '' }}>
            <Chevron />
          </RotatedChevron>
        </ActiveFilter>

        <PopupContainer>
          <Popup
            isVisible={this.state.isOpen}
            onClickOnBackdrop={this.handleClickOnBackdrop}
            isControlled
          >
            <DropdownList>
              {this.props.filters.map(item => (
                <FilterItem
                  key={item.value}
                  item={item}
                  onClick={this.handleFilterChange}
                  activeFilter={this.props.activeFilter}
                />
              ))}
            </DropdownList>
          </Popup>
        </PopupContainer>
      </FilterWrapper>
    );
  }
}

FiltersDropdown.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.string,
    can: PropTypes.bool,
  })).isRequired,
  activeFilter: PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.string,
  }),
  onFilterChange: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.string),
};

FiltersDropdown.defaultProps = {
  onFilterChange: () => {},
  style: {},
  activeFilter: {},
};

export default FiltersDropdown;
